<template>
  <v-dialog v-model="show" max-width="400">
    <v-card>
      <v-card-title class="text-subtitle-1 pa-3">
        Vacaciones {{ selectedUser ? selectedUser.name : '' }} - {{ year }}
      </v-card-title>
      <v-card-text class="pa-2">
        <v-table density="compact">
          <thead>
            <tr>
              <th class="text-left py-2">Mes</th>
              <th class="text-center py-2" width="80">Días</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dias, index) in vacaciones" :key="index">
              <td class="py-1">{{ meses[index] }}</td>
              <td class="text-center py-1">
                <v-chip
                  :color="dias > 0 ? 'info' : 'grey-lighten-2'"
                  :text-color="dias > 0 ? 'white' : ''"
                  size="x-small"
                  class="font-weight-medium"
                >
                  {{ dias }}
                </v-chip>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td class="text-left font-weight-bold py-2">Total</td>
              <td class="text-center py-2">
                <v-chip
                  color="primary"
                  text-color="white"
                  size="small"
                  class="font-weight-medium text-center"
                >
                  {{ totalDias }}
                </v-chip>
              </td>
            </tr>
          </tfoot>
        </v-table>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          variant="text"
          density="comfortable"
          @click="show = false"
        >
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
// import { ref, computed } from 'vue'
import { computed } from 'vue'

const props = defineProps({
  modelValue: Boolean,
  vacaciones: {
    type: Array,
    default: () => Array(12).fill(0)
  },
  year: {
    type: Number,
    required: true
  },
  selectedUser: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['update:modelValue'])

const meses = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre'
]

const show = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const totalDias = computed(() => {
  return props.vacaciones.reduce((sum, dias) => sum + dias, 0)
})
</script>

<style scoped>
.v-table {
  background-color: transparent !important;
}

:deep(.v-table__wrapper) {
  border-radius: 8px;
}

:deep(.v-table tbody tr:hover) {
  background-color: rgba(var(--v-theme-primary), 0.04);
}

:deep(.v-chip) {
  min-width: 32px;
}
</style>
